import { render, staticRenderFns } from "./detailsPiePlace.vue?vue&type=template&id=32ddc0a4&scoped=true&"
import script from "./detailsPiePlace.vue?vue&type=script&lang=js&"
export * from "./detailsPiePlace.vue?vue&type=script&lang=js&"
import style0 from "./detailsPiePlace.vue?vue&type=style&index=0&id=32ddc0a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ddc0a4",
  null
  
)

export default component.exports